import About from "@/components/shared/about/About.vue";

export default {
    name: "AboutView",
    components: { About },
    computed: {},
};
